// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2GVe8","unreadBadge":"styles_unreadBadge__1yubA","modalContent":"styles_modalContent___6zG6","modal":"styles_modal__D3n-O"};